import { render } from "./MediaText.vue?vue&type=template&id=a3a29cd2"
import script from "./MediaText.vue?vue&type=script&lang=js"
export * from "./MediaText.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__